// 引入文件
import request from "../utils/request";

/**
 *  用户登录
 * @method post
 * @return {[type]}         [description]
 */
export function postLogin(data) {
  // console.log(data)
  return request({
    url: "/other/data",
    method: "post",
    params: {
      ...data,
    },
  });
}

/**
 *  用户注册
 * @method post
 * @return {[type]}         [description]
 */
export function postRegister(data) {
  // console.log(data)
  return request({
    url: "/other/data",
    method: "post",
    params: {
      ...data,
    },
  });
}

/**
 *  找回密码
 * @method post
 * @return {[type]}         [description]
 */
export function postRetrievePassword(data) {
  // console.log(data)
  return request({
    url: "/other/data",
    method: "post",
    params: {
      ...data,
    },
  });
}

/**
 *  老师加盟
 * @method post
 * @return {[type]}         [description]
 */
export function postJoin(data) {
  return request({
    url: "Agent/Join",
    method: "post",
    "Content-Type": "application/x-www-form-urlencoded",
    data,
  });
}

/**
 *  下载地址
 * @method post
 * @return {[type]}         [description]
 */
export function getDownload() {
  return request({
    url: "//www.ihatoo.com/download",
    method: "get",
  });
}

/**
 *  申请试读
 * @method post
 * @return {[type]}         [description]
 */
export function postSignup(data) {
  data.hasOwnProperty("applySource") || (data.applySource = 5);
  data.hasOwnProperty('verifyCode') || (data.verifyCode = '88888888');

  return request({
    url: "v2/operation/api/static/apply",
    method: "post",
    "Content-Type": "application/x-www-form-urlencoded",
    data,
  });
}

/**
 *  发送手机验证码
 * @method post
 * @return {[type]}         [description]
 */
export function SendSms(data) {
  data.hasOwnProperty("applySource") || (data.applySource = 5);
  return request({
    url: "v2/sys/api/static/send/sms",
    method: "post",
    data,
  });
}
